import { AlertChangeCheckbox } from './AlertChangeCheckbox';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { StakeholderEmailCellEditor } from './StakeholderEmailCellEditor';
import { StakeholderNameCellEditor } from './StakeholderNameCellEditor';
import { StakeholderTypeDisplay } from './StakeholderTypeDisplay';
const nameColumn = {
    className: 'no-padding-cell',
    dataIndex: 'name',
    key: 'name',
    render: (_, stakeholder) => React.createElement(StakeholderNameCellEditor, { stakeholderId: stakeholder.stakeholderId }),
    title: COPY_SPECIFIC.NAME,
    width: '20%'
};
const emailColumn = {
    className: 'no-padding-cell',
    dataIndex: 'email',
    key: 'email',
    render: (_, stakeholder) => React.createElement(StakeholderEmailCellEditor, { stakeholderId: stakeholder.stakeholderId }),
    title: COPY_SPECIFIC.EMAIL,
    width: '200px'
};
const typeColumn = {
    className: 'center-align-cell',
    dataIndex: 'stakeholderType',
    key: 'stakeholderType',
    render: (value) => React.createElement(StakeholderTypeDisplay, { type: value }),
    title: COPY_SPECIFIC.TYPE,
    width: '115px'
};
const countColumn = {
    align: 'right',
    dataIndex: 'sonarObjectRefCount',
    key: 'sonarObjectRefCount',
    title: COPY_SPECIFIC.ENTITY_STAKEHOLDER,
    width: '120px'
};
const alertColumn = {
    align: 'center',
    dataIndex: 'alertMetadataChanges',
    key: 'alertMetadataChanges',
    render: (_, stakeholder) => React.createElement(AlertChangeCheckbox, { stakeholderId: stakeholder.stakeholderId }),
    title: COPY_SPECIFIC.ALERT_TO_CHANGES
};
export function getColumns() {
    return [nameColumn, emailColumn, typeColumn, countColumn, alertColumn];
}
